import React, { memo } from 'react';

import TableCell from './cell';

const TableCells = ( { cells } ) => Array.isArray(cells) ? cells.map( (cell ) => <TableCell {...cell} /> ) : null;

export default memo(TableCells);